"use strict";
/* eslint-disable no-shadow */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PredefinedDepartmentTypes = exports.DepartmentResponsibilities = void 0;
var DepartmentResponsibilities;
(function (DepartmentResponsibilities) {
    DepartmentResponsibilities["AGRICULTURE"] = "agriculture";
    DepartmentResponsibilities["ANIMAL_CONTROL"] = "animal-control";
    DepartmentResponsibilities["AVIATION"] = "aviation";
    DepartmentResponsibilities["BUILDING_AND_ZONING"] = "building-and-zoning";
    DepartmentResponsibilities["CITY_CLERK"] = "city-clerk";
    DepartmentResponsibilities["BUDGET"] = "budget";
    DepartmentResponsibilities["COMMUNICATIONS"] = "communications";
    DepartmentResponsibilities["COMMUNITY_RELATIONS"] = "community-relations";
    DepartmentResponsibilities["CULTURAL_AFFAIRS"] = "cultural-affairs";
    DepartmentResponsibilities["ECONOMIC_DEVELOPMENT"] = "economic-development";
    DepartmentResponsibilities["EDUCATION"] = "education";
    DepartmentResponsibilities["EMERGENCY_MANAGEMENT"] = "emergency-management";
    DepartmentResponsibilities["ENGINEERING"] = "engineering";
    DepartmentResponsibilities["ENVIRONMENTAL_SERVICES"] = "environmental-services";
    DepartmentResponsibilities["FINANCIAL_ADMIN_SERVICES"] = "financial-admin-services";
    DepartmentResponsibilities["FIRE_RESCUE"] = "fire-rescue";
    DepartmentResponsibilities["HOUSING"] = "housing";
    DepartmentResponsibilities["HUMAN_RESOURCES"] = "human-resources";
    DepartmentResponsibilities["IT_INFORMATION_SERVICES"] = "it-information-services";
    DepartmentResponsibilities["INNOVATION"] = "innovation";
    DepartmentResponsibilities["LEGISLATIVE"] = "legislative";
    DepartmentResponsibilities["PARKS_RECREATION"] = "parks-recreation";
    DepartmentResponsibilities["PLANNING_AND_DEVELOPMENT"] = "planning-development";
    DepartmentResponsibilities["PUBLIC_SAFETY"] = "public-safety";
    DepartmentResponsibilities["PUBLIC_HEALTH"] = "public-health";
    DepartmentResponsibilities["PUBLIC_WORKS"] = "public-works";
    DepartmentResponsibilities["WASTE_MANAGEMENT"] = "waste-management";
    DepartmentResponsibilities["SOCIAL_SERVICES"] = "social-services";
    DepartmentResponsibilities["TOURISM"] = "tourism";
    DepartmentResponsibilities["TRANSPORTATION"] = "transportation";
    DepartmentResponsibilities["TRANSIT_AUTHORITY"] = "transity-authority";
    DepartmentResponsibilities["INFRASTRUCTURE"] = "infrastructure";
    DepartmentResponsibilities["WATER_WASTEWATER_UTILITIES"] = "water-wastewater-utilities";
    DepartmentResponsibilities["DEI"] = "dei";
    DepartmentResponsibilities["REPORTS_AUDITS"] = "reports-audits";
    DepartmentResponsibilities["CODE_ENFORCEMENT"] = "code-enforcement";
    DepartmentResponsibilities["LIBRARIES"] = "libraries";
    DepartmentResponsibilities["LICENSING_PERMITTING"] = "licensing-permitting";
    DepartmentResponsibilities["ZOO"] = "zoo";
    DepartmentResponsibilities["OTHER"] = "other";
    DepartmentResponsibilities["PROPERTY_ASSESSMENT"] = "property-assessment";
    DepartmentResponsibilities["COUNTY_COMMISSION"] = "county-commission";
    DepartmentResponsibilities["CLERK_RECORDER"] = "clerk-recorder";
    DepartmentResponsibilities["COMMUNITY_DEVELOPMENT"] = "community-development";
    DepartmentResponsibilities["COURT_SYSTEM"] = "court-system";
    DepartmentResponsibilities["PUBLIC_DEFENSE"] = "public-defense";
    DepartmentResponsibilities["PROBATION"] = "probation";
    DepartmentResponsibilities["SUSTAINABILITY"] = "sustainability";
    DepartmentResponsibilities["TAX_COLLECTIONS"] = "tax-collections";
    DepartmentResponsibilities["VETERANS_AFFAIRS"] = "veterans-affairs";
    DepartmentResponsibilities["ELECTIONS"] = "elections";
    DepartmentResponsibilities["JAILS"] = "jails";
    DepartmentResponsibilities["FISCAL_AFFAIRS"] = "fiscal-affairs";
    DepartmentResponsibilities["ADMINISTRATION"] = "administration";
    DepartmentResponsibilities["PATROL_OPERATIONS"] = "patrol-operations";
    DepartmentResponsibilities["INVESTIGATIVE_SERVICES"] = "investigative-services";
    DepartmentResponsibilities["SUPPORT_SERVICES"] = "support-services";
    DepartmentResponsibilities["COURT_SERVICES"] = "court-services";
    DepartmentResponsibilities["CORRECTIONS"] = "corrections";
})(DepartmentResponsibilities = exports.DepartmentResponsibilities || (exports.DepartmentResponsibilities = {}));
var PredefinedDepartmentTypes;
(function (PredefinedDepartmentTypes) {
    PredefinedDepartmentTypes["MAYOR_OFFICE"] = "mayor-office";
    PredefinedDepartmentTypes["CITY_MANAGER_OFFICE"] = "city-manager-office";
    PredefinedDepartmentTypes["CITY_COUNCIL"] = "city-council";
    PredefinedDepartmentTypes["COUNTY_ADMIN_MAYOR"] = "county-admin-mayor";
    PredefinedDepartmentTypes["COUNTY_COUNCIL"] = "county-council";
    PredefinedDepartmentTypes["COMMISSIONERS_SUPERVISORS_BOARD"] = "commissioners-supervisors-board";
    PredefinedDepartmentTypes["COURT"] = "court";
    PredefinedDepartmentTypes["CLERKS_OFFICE"] = "clerks-office";
    PredefinedDepartmentTypes["AUDITOR"] = "auditor";
    PredefinedDepartmentTypes["COMMUNICATIONS"] = "communications";
    PredefinedDepartmentTypes["CHIEF_ADMINISTRATION"] = "chief-administration";
    PredefinedDepartmentTypes["OPERATIONS"] = "operations";
    PredefinedDepartmentTypes["INVESTIGATION"] = "investigation";
})(PredefinedDepartmentTypes = exports.PredefinedDepartmentTypes || (exports.PredefinedDepartmentTypes = {}));
